import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import LoadingSpinner from "../../../common/components/functional/loadingSpinner/LoadingSpinner";
import { PayslipDetailed } from "./payslipAPI";
import { PayslipDetailsContent } from "./PayslipDetailsContent";

type Props = {
  payslip: PayslipDetailed | undefined;
  isOpen: boolean;
  onClose: () => void;
};

export const PayslipDetails = ({ payslip, isOpen, onClose }: Props) => {
  return (
    <DialogComponent
      // Backdrop click is enabled for usability purposes
      disableBackdropClick={false}
      open={isOpen}
      onClose={onClose}
      sx={{
        width: "445px",
        maxHeight: "90%",
        overflowY: "scroll",
        scrollbar: "hidden",
        scrollbarWidth: "none",
      }}
    >
      {!payslip ? (
        <LoadingSpinner />
      ) : (
        <PayslipDetailsContent payslip={payslip} onClose={onClose} />
      )}
    </DialogComponent>
  );
};
